<template>
  <div>
    <div class="container" align="center">
      <div class="flex justify-content-center w-100">
        <div id="btn-radios-4" class="categoryRadioGroup">
          <label class="cateBoxContainer">
            <input type="radio" value="윤리규범" v-model="tab_name" />
            <div class="cateBox">
              <div class="innerText">{{ $t('title1') }}</div>
            </div>
          </label>
          <label class="cateBoxContainer">
            <input type="radio" value="윤리규범 실천지침" v-model="tab_name" />
            <div class="cateBox">
              <div class="innerText">{{ $t('title2') }}</div>
            </div>
          </label>
          <label class="cateBoxContainer">
            <input type="radio" value="상담 및 제보" v-model="tab_name" />
            <div class="cateBox">
              <div class="innerText">{{ $t('title3') }}</div>
            </div>
          </label>
        </div>
      </div>

      <Codeofethics v-if="tab_name === '윤리규범'" />
      <Practiceguideline v-if="tab_name === '윤리규범 실천지침'" />
      <Consultation v-if="tab_name === '상담 및 제보'" />
    </div>
  </div>
</template>

<script>
import Codeofethics from '@/pages/Footerlink/Components/Codeofethics';
import Practiceguideline from '@/pages/Footerlink/Components/Practiceguideline';
import Consultation from '@/pages/Footerlink/Components/Consultation';

export default {
  name: 'Ethicalmanagement',
  data() {
    return {
      tab_name: '윤리규범',
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('ethical_management')});
  },
  components: {Codeofethics, Practiceguideline, Consultation},
};
</script>

<style scoped lang="scss">
.categoryRadioGroup {
  width: 100%;
  height: 3rem;
}

.cateBoxContainer {
  width: 33%;
  height: 100%;
  border: 1px solid #b7b7b7;
  margin: 0rem;
}

input[type='radio'] {
  display: none;
  & {
    + .cateBox {
      display: table;
      width: 100%;
      height: 100%;
      background-color: white;
      font-weight: bold;
      padding: 0.2rem;
      cursor: pointer;
      .innerText {
        display: table-cell;
        vertical-align: middle;
        margin-top: auto;
        margin-bottom: auto;
        align-self: center;
        word-break: keep-all;
      }
    }
  }
  &:checked {
    + .cateBox {
      background-color: #524a3d;
      color: white;
    }
  }
}
@media (min-width: 992px) {
  .innerText {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .innerText {
    font-size: 0.8rem;
  }
}
</style>

<i18n>
{
  "ko": {
    "title1": "윤리규범",
    "title2": "윤리규범 실천지침",
    "title3": "상담 및 제보",
    "ethical_management": "윤리경영"
  },
  "en": {
    "title1": "Code of Ethics",
    "title2": "Code of Ethics Practice Guidelines",
    "title3": "Consultation and Reporting",
    "ethical_management": "Ethical Management"
  },
  "ja": {

  }
}
</i18n>
